import React from 'react';
import CompanyMappingMatrix from 'components/CompanyMapping/CompanyMappingMatrix';

export default function MatrixSlide({ sectionNumber, ideas }) {
    return (
        <div className="h-full w-full bg-[#d6d6d6] p-8 md:p-16 overflow-y-auto relative">
            {/* Logo */}
            <div className="absolute top-8 right-8 md:top-16 md:right-16">
                <img
                    src="/images/opificioai-logo.png"
                    alt="OpificioAI"
                    className="h-6 md:h-8 w-auto opacity-60"
                />
            </div>

            <div className="max-w-6xl mx-auto">
                {/* Section Number */}
                <div className="text-[80px] md:text-[120px] font-bold text-black/10 leading-none mb-4">
                    {sectionNumber}
                </div>

                <h2 className="text-3xl md:text-5xl font-bold text-black/90 mb-4">
                    Matrice di Priorità
                </h2>

                <p className="text-lg text-black/50 mb-12">
                    Visualizzazione basata su <span className="text-black/70 font-medium">Impatto Aziendale</span> vs <span className="text-black/70 font-medium">Facilità di Implementazione</span>
                </p>

                {/* Matrix Chart */}
                <div className="bg-white rounded-2xl p-6 shadow-sm">
                    <CompanyMappingMatrix ideas={ideas} />
                </div>

                {/* Legend */}
                <div className="mt-8 bg-white rounded-2xl p-6 shadow-sm">
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
                        <div className="p-4">
                            <div className="text-sm font-semibold text-black/60 uppercase tracking-wider mb-1">
                                Quick Wins
                            </div>
                            <div className="text-xs text-black/40">
                                Alto impatto, facile
                            </div>
                        </div>
                        <div className="p-4">
                            <div className="text-sm font-semibold text-black/60 uppercase tracking-wider mb-1">
                                Major Projects
                            </div>
                            <div className="text-xs text-black/40">
                                Alto impatto, complesso
                            </div>
                        </div>
                        <div className="p-4">
                            <div className="text-sm font-semibold text-black/60 uppercase tracking-wider mb-1">
                                Fill-ins
                            </div>
                            <div className="text-xs text-black/40">
                                Basso impatto, facile
                            </div>
                        </div>
                        <div className="p-4">
                            <div className="text-sm font-semibold text-black/60 uppercase tracking-wider mb-1">
                                Thankless Tasks
                            </div>
                            <div className="text-xs text-black/40">
                                Basso impatto, complesso
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
